export const iconFontAwesomeMedicalHealthHeart = (
	<i className="fa-solid fa-heart"></i>
);
